module.exports = __webpack_public_path__ + "static/media/drone.e9f626d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/content/map/videos/drone.svg
// module id = 1337
// module chunks = 0